<template>
  <Instance
    instance="supplier"
    instance-name="Supplier"
    :create="d => suppliers.create(d)"
    :delete="d => suppliers.remove(d)"
    :update="d => suppliers.update(d)"
    :get="d => suppliers.get(d)"
    :upsert="upsert"
    :details="details"
    :columns="columns"
    :hideDelete="!isCommonAdmin"
  />
</template>

<script>
import { BIconPencil, BIconCardText } from 'bootstrap-vue';

import Instance from '../../CRUD/instance';
import { AuthMixin } from '../../../../mixins';
import api from '../../../api';

export default {
  title: 'Suppliers',
  components: { Instance },
  mixins: [AuthMixin],
  data() {
    return {
      suppliers: api.suppliers,
      upsert: [
        { value: 'company', name: 'Company', required: true },
        { value: 'companyHeadquarters', name: 'Company headquarters' },
        { value: 'branch', name: 'Branch' },
        { value: 'contactPerson', name: 'Contact Person' },
        { value: 'businessHours', name: 'Business hours' },
        { value: 'contactDetails', name: 'Contact details', type: 'select', data: [] }
      ],
      details: [
        {
          header: 'DETAILS',
          content: [
            { value: 'company', name: 'Company' },
            { value: 'companyHeadquarters', name: 'Company headquarters' },
            { value: 'branch', name: 'Branch' },
            { value: 'contactPerson', name: 'Contact Person' },
            { value: 'businessHours', name: 'Business hours' },
            {
              value: 'contactDetails',
              name: 'Contact details',
              render: o =>
                `${o.email ? `${o.email} (${this.$translate('Email')}) / ` : ''}${
                  o.telephoneNumber ? `${o.telephoneNumber} (${this.$translate('Telephone Number')})` : ''
                }${o.mobileNumber ? ` / ${o.mobileNumber} (${this.$translate('Mobile Number')})` : ''}`
            }
          ]
        }
      ]
    };
  },
  async created() {
    const contactDetails = await api.contactDetails.get();
    this.upsert.forEach(i => {
      if (i.value === 'contactDetails') {
        i.data = contactDetails.map(c => ({ value: c.id, text: `${c.telephoneNumber} (${c.email})` }));
      }
    });
  },
  methods: {
    columns({ editInstance, instanceDetails }) {
      return [
        {
          field: 'check',
          key: '1',
          type: 'checkbox',
          title: '',
          width: 50,
          align: 'center'
        },
        {
          field: 'company',
          title: this.$translate('Company'),
          key: '2',
          sortBy: '',
          align: 'left'
        },
        {
          field: 'companyHeadquarters',
          title: this.$translate('Company headquarters'),
          key: '3',
          sortBy: '',
          align: 'left'
        },
        {
          field: 'branch',
          title: this.$translate('Branch'),
          key: '4',
          sortBy: '',
          align: 'left'
        },
        {
          field: 'actions',
          title: '',
          key: '10',
          width: 110,
          renderBodyCell: ({ row }) => {
            return (
              <div class="action-block">
                <div class="details-action" on-click={() => editInstance(row)}>
                  <BIconPencil />
                </div>
                <div class="details-action" on-click={() => instanceDetails(row)}>
                  <BIconCardText />
                </div>
              </div>
            );
          }
        }
      ];
    }
  }
};
</script>
